import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const COMPANIES = ['Groupon', 'Workato', 'Testim', 'Sprout Social', 'Morningstar', 'Jellyvision'];
export function Home() {
  return <div className="min-h-screen bg-[#fdf9e6]" data-id="element-71">
      <div className="max-w-4xl mx-auto px-6 sm:px-10 pt-20 sm:pt-28 pb-16" data-id="element-72">
        <motion.section initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-73">
          <h1 className="text-3xl sm:text-4xl md:text-[2.75rem] font-semibold leading-[1.2] tracking-tight text-[#0a0e2e]" data-id="element-74">
            Hi my name is Adomas, I am a UX designer based in Chicago.
          </h1>
          <p className="mt-10 text-lg sm:text-xl leading-relaxed text-[#0a0e2e]/75" data-id="element-75">
            Over the last decade, I've helped SaaS companies, marketplaces, and
            startups design products that delight users and drive business
            results. From onboarding flows that triple activation rates to
            automation tools that save hours of manual work, my goal is always
            the same: design that works beautifully for people and the business.
            Explore my{' '}
            <Link to="/work" className="underline underline-offset-4 decoration-2 decoration-[#0a0e2e]/40 hover:decoration-[#0a0e2e] transition-all" data-id="element-76">
              case studies
            </Link>{' '}
            to see how I approach problems, collaborate with teams, and deliver
            measurable impact.
          </p>
        </motion.section>

        <motion.section initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-32 sm:mt-40" data-id="element-77">
          <p className="text-center text-base text-[#0a0e2e]/60 mb-14" data-id="element-78">
            I've worked alongside a few amazing teams at these fine companies:
          </p>

          {/* Company logos - replace these placeholders with your actual company logo images */}
          <div className="flex flex-wrap justify-center items-center gap-10 sm:gap-16" data-id="element-79">
            {COMPANIES.map((company, i) => <motion.div key={company} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.4 + i * 0.07
          }} className="flex items-center justify-center" data-id="element-80">
                {/* Replace with <img src="..." alt={company} /> for real logos */}
                <div className="h-10 px-4 flex items-center justify-center rounded bg-[#0a0e2e]/[0.06]" data-id="element-81">
                  <span className="text-sm font-semibold tracking-wide text-[#0a0e2e]/50" data-id="element-82">
                    {company}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </motion.section>
      </div>
    </div>;
}